import { getStorageValue, setStorageValue } from '@lingoda/utils';

type BrowserTimeSyncErrorReports = {
    hour: string;
    count: number;
};

type ReportDecision =
    | { shouldReport: true; nextReports: BrowserTimeSyncErrorReports }
    | { shouldReport: false };

const BROWSER_TIME_SYNC_ERROR_REPORTS_KEY = 'browserTimeSyncErrorReports';
const MAX_REPORTS_PER_HOUR = 6;

const isBrowserTimeSyncErrorReports = (value: unknown): value is BrowserTimeSyncErrorReports => {
    const reports = value as Partial<BrowserTimeSyncErrorReports> | undefined;

    return !!reports && typeof reports.hour === 'string' && typeof reports.count === 'number';
};

export const countBrowserTimeSyncErrorReport = ({
    stored,
    hour,
}: {
    stored: unknown;
    hour: string;
}): ReportDecision => {
    if (!isBrowserTimeSyncErrorReports(stored) || stored.hour !== hour) {
        return { shouldReport: true, nextReports: { hour, count: 1 } };
    }

    if (stored.count >= MAX_REPORTS_PER_HOUR) {
        return { shouldReport: false };
    }

    return { shouldReport: true, nextReports: { hour, count: stored.count + 1 } };
};

export const shouldReportBrowserTimeSyncError = (hour: string) => {
    const decision = countBrowserTimeSyncErrorReport({
        stored: getStorageValue<BrowserTimeSyncErrorReports>(BROWSER_TIME_SYNC_ERROR_REPORTS_KEY),
        hour,
    });

    if (decision.shouldReport) {
        setStorageValue(BROWSER_TIME_SYNC_ERROR_REPORTS_KEY, decision.nextReports);
    }

    return decision.shouldReport;
};
